import { ConcentricLayout } from '@antv/layout/lib/layout/concentric';

export default ConcentricLayout;
